import { extendObservable } from 'mobx';
import PropTypes from 'prop-types';
import { LS_KEY } from '../LocalStorage';
import FlagStore from './FlagStore';
import syncStoreWithLocalStorage from './helpers/syncStoreWithLocalStorage';

export default class ConsoleNavigationStore {
    static PropType = PropTypes.shape({
        expanded: FlagStore.PropType.isRequired,
        dashboardToggle: FlagStore.PropType.isRequired,
        udToggle: FlagStore.PropType.isRequired,
        browserToggle: FlagStore.PropType.isRequired,
        policiesToggle: FlagStore.PropType.isRequired,
        newPoliciesToggle: FlagStore.PropType.isRequired,
        productSettingsToggle: FlagStore.PropType.isRequired,
        administratorsToggle: FlagStore.PropType.isRequired,
        customizeUIToggle: FlagStore.PropType.isRequired,
    });

    constructor(data = {}, useLocalStorage = false) {
        this.useLocalStorage = useLocalStorage;

        const sync = this.useLocalStorage ? syncStoreWithLocalStorage : (x) => x;

        extendObservable(this, /** @class ConsoleNavigationStore */{
            expanded: sync(new FlagStore(false), LS_KEY.consoleNavigation),
            dashboardToggle: sync(new FlagStore(true), LS_KEY.consoleNavigationDashboard),
            udToggle: sync(new FlagStore(true), LS_KEY.consoleNavigationUD),
            browserToggle: sync(new FlagStore(true), LS_KEY.consoleNavigationBrowser),
            policiesToggle: sync(new FlagStore(true), LS_KEY.consoleNavigationPolicies),
            newPoliciesToggle: sync(new FlagStore(true), LS_KEY.consoleNavigationNewPolicies),
            productSettingsToggle: sync(new FlagStore(true), LS_KEY.consoleNavigationProductSettings),
            administratorsToggle: sync(new FlagStore(true), LS_KEY.consoleNavigationAdministrators),
            customizeUIToggle: sync(new FlagStore(true), LS_KEY.consoleNavigationCustomizeUI),
            pinned: sync(new FlagStore(true), LS_KEY.consoleNavigationPinned),
        }, data);
    }
}
